export function replaceStr2Html (str) {
  return str.replaceAll('\n', '<br/>')
}

export function replaceHtml2Str (html) {
  return html
    .replaceAll('<br/>', '\n')
    .replaceAll('<br>', '\n')
}
